import CustomerList from "../../components/customer/CustomerList";

const CustomersPage = () => {

    return <CustomerList/>
}

export default CustomersPage;
